import React, {Component} from 'react';
import classes from './Image.module.css'
import LazyLoad from 'react-lazy-load';

class Image extends Component {
    constructor() {
        super();
        this.state = {};
        this.fallback = () => {
            if (this.props.fallbackSrc) {
                this.setState({failed: true});
            }
        };
    }

    render() {

        let cName = ''
        if (this.props.cName === 'employeeIcon') cName = classes.employeeIcon

        if (this.state.failed || this.props.src === null) {
            return (
                (this.props.ifLazyLoad) ? <LazyLoad className={classes.lazyLoadImage}
                                                    width={this.props.size}
                                                    height={this.props.size}
                                                    debounce={false}
                    >
                        <img className={cName}
                             src={this.props.fallbackSrc}
                             alt="Default Icon"
                             width="100%" height="100%"
                             style={{aspectRatio: "1/1", borderRadius: (this.props.radius) ? (String(this.props.radius).indexOf('%')) !== -1 ? `${this.props.radius}` : `${this.props.radius}px` : null}}
                        />
                    </LazyLoad>
                    : <img className={cName}
                           src={this.props.fallbackSrc}
                           alt="Default Icon"
                           width={this.props.size} height={this.props.size}
                           style={{aspectRatio: "1/1", borderRadius: (this.props.radius) ? (String(this.props.radius).indexOf('%')) !== -1 ? `${this.props.radius}` : `${this.props.radius}px` : null}}
                    />
            )
        } else {
            return (
                (this.props.ifLazyLoad) ? <LazyLoad className={classes.lazyLoadImage}
                                                    width={this.props.size}
                                                    height={this.props.size}
                                                    debounce={false}
                    >
                        <img className={cName}
                             src={this.props.src}
                             onError={this.fallback}
                             width="100%" height="100%"
                             alt="Profile Icon"
                             style={{aspectRatio: "1/1", objectFit: "cover", borderRadius: (this.props.radius) ? (String(this.props.radius).indexOf('%')) !== -1 ? `${this.props.radius}` : `${this.props.radius}px` : null}}/>
                    </LazyLoad> :
                    <img className={cName}
                         src={this.props.src}
                         onError={this.fallback}
                         width={this.props.size} height={this.props.size}
                         alt="Profile Icon"
                         style={{aspectRatio: "1/1", objectFit: "cover", borderRadius: (this.props.radius) ? (String(this.props.radius).indexOf('%')) !== -1 ? `${this.props.radius}` : `${this.props.radius}px` : null}}
                    />
            )
        }
    }
}

export default Image
